import { wrapClientApiCall } from '../../../utils'
import { successCallback } from './successCallback'

export const fetchConsumerCarts = () =>
    wrapClientApiCall({
        actionRoot: 'FETCH_CONSUMER_CARTS',
        url: `api/carts`,
        successCallback,
    })
